import {createContext, useContext, useEffect, useState} from "react";

const ProjectContext = createContext(null);

export function ProjectContextProvider({ children }) {
    const [project, setProject] = useState(() => {
        const saved = localStorage.getItem("selectedProject");

        return saved ? JSON.parse(saved) : null;
    });

    useEffect(() => {
        if (project) {
            localStorage.setItem(
                "selectedProject",
                JSON.stringify(project)
            );
        } else {
            localStorage.removeItem("selectedProject");
        }
    }, [project]);

    return (
        <ProjectContext.Provider value={{ project, setProject }}>
            {children}
        </ProjectContext.Provider>
    );
}

export function useProject() {
    return useContext(ProjectContext);
}